<template>
<div class="chapter">
<div class="inner_page">
<h1 class="block_11" id="id_Toc172901704">Part 1: Ben’s Small World</h1>
<p class="block_5" id="calibre_pb_6"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?66732fff